import $ from 'jquery';
const FloatingBottom = {
    created() { },
    mounted(el, binding, vnode) {
        let element = el, $element = $(el);
        const offsetBotomInicial = 33;
        const initialMarginLeft = -26;
        $element.addClass('v-floating-bottom');
        $element.css({
            'position': 'fixed',
            'background-color': '#fff',
            'bottom': offsetBotomInicial,
            'width': '100%',
            'margin-left': initialMarginLeft,
            'margin-top': '0px',
            'padding': '10px 244px 10px 20px',
            'z-index': 500,
            'border-top': '5px solid #ecf0f5',
        });
        $('.content-wrapper').css({
            'padding-bottom': '100px',
        });
        $('footer.main-footer').css({
            'position': 'fixed',
            'bottom': '0px',
            'width': '100%',
        });
        const getAlturaDropDown = ($element) => {
            let altura = $element.find('.dropdown-menu').offsetHeight;
            for (let i = 0; i < $element.find('.dropdown-menu li').length; i++) {
                if ($element.find('.dropdown-menu li').eq(i).offsetHeight) {
                    altura += $element.find('.dropdown-menu li').eq(i).offsetHeight;
                }
            }
            return altura;
        };
        /**
         * Quando abre um dropdown dentro do floating bottom é preciso tirar o overflow para ser corretamennte exibido
         */
        const handleResponsivity = () => {
            $(document).on('show.bs.dropdown', '.v-floating-bottom .dropup', function (event) {
                $element.css('margin-left', (element.scrollLeft * -1) + initialMarginLeft);
                $element.css('width', element.offsetWidth + element.scrollLeft);
                $element.addClass('dropup-opened');
                const alturaUl = getAlturaDropDown($element);
                $element.find('.dropdown-menu').css('top', alturaUl);
            });
            $(document).on('hide.bs.dropdown', '.v-floating-bottom .dropup', function (event) {
                $element.css('margin-left', initialMarginLeft);
                $element.css('width', '100%');
                $element.removeClass('dropup-opened');
            });
        };
        handleResponsivity();
    }
};
export default FloatingBottom;
